import {useSelector} from 'react-redux';
import {groupRiskStatus} from '../../../util/uiconstants';

export default () =>
	useSelector(({reconciliations}) => {
		const {componentName, engagementId, primaryRisks, primaryAccounts, engagementDescription} = reconciliations.selected;

		if (componentName === null)
			return {
				componentName: '',
				engagementId: 0,
				engagementDescription: '',
				openAccountsCount: 0,
				assessedAccountsCount: 0,
				openRisksCount: 0,
				assessedRisksCount: 0
			};

		const filterRisks = (type) => ({groupRiskStatusId}) => groupRiskStatusId === type;

		const openAccountsCount = primaryAccounts?.filter(
			({groupRiskStatusId}) =>
				groupRiskStatusId === groupRiskStatus.open || groupRiskStatusId === groupRiskStatus.systemReOpened
		)?.length;
		const assessedAccountsCount = primaryAccounts?.filter(
			({groupRiskStatusId}) => groupRiskStatusId === groupRiskStatus.assessed
		)?.length;

		const openRisksCount = primaryRisks?.filter(
			({groupRiskStatusId}) =>
				groupRiskStatusId === groupRiskStatus.open || groupRiskStatusId === groupRiskStatus.systemReOpened
		)?.length;
		const assessedRisksCount = primaryRisks?.filter(filterRisks(groupRiskStatus.assessed))?.length;

		return {
			componentName,
			engagementId,
			engagementDescription,
			openAccountsCount,
			assessedAccountsCount,
			openRisksCount,
			assessedRisksCount
		};
	});
